<template>
    <div
        class="m-related"
        @drop="onDrop($event)"
        @dragover.prevent
    >
        <div class="m-related__header">
            <p class="m-related__title a-title a-title--small">Zamów również</p>
        </div>
        <div
            v-if="featuredPackages || dragSamplePackageDayId === 'relatedProducts'"
            class="m-related__content"
        >
            <div
                class="m-product m-product--featured m-product--sample"
                v-if="dragSamplePackageDayId === 'relatedProducts' && dragPackageDayInWeek !== null"
            >
                <figure class="m-product__image">
                    <img
                        src="@/assets/pack.jpg"
                        alt="product"
                        class="m-product__imageImg"
                    >
                </figure>
                <div>
                    <p class="m-product__title"></p>
                    <div class="m-product__data">
                        <p class="m-product__price"></p>
                        <p class="m-product__amount a-label"></p>
                    </div>
                </div>
            </div>
            <offer-product-box-related
                v-for="product in featuredPackages"
                v-bind:key="product.id"
                :address-id="currentAddressId"
                :product="product"
            />
        </div>
    </div>
</template>

<script>
import OfferProductBoxRelated from '@/components/offer/OfferProductBoxRelated'
export default {
    components: {
        OfferProductBoxRelated
    },
    computed: {
        featuredPackages() {
            return this.$store.getters.offerFeaturedPackages
        },
        currentAddressId() {
            return this.$store.getters.currentAddressId
        },
        dragSamplePackageDayId() {
            return this.$store.getters.dragSamplePackageDayId
        },
        weekOrders() {
            return this.$store.getters.weekOrders
        },
        dragPackageDayInWeek() {
            return this.$store.getters.dragPackageDayInWeek
        }
    },
    methods: {
        onDrop($event) {
            const orderId = parseInt($event.dataTransfer.getData('orderId'))
            const productId = parseInt($event.dataTransfer.getData('productId'))
            const order = this.weekOrders.find(item => item.product.id === productId)
            if(!isNaN(orderId)) {
                // add product to features
                const featuredPackages = Array.from(this.featuredPackages)
                featuredPackages.push(order.product)
                this.$store.dispatch('setOfferFeaturedPackages', featuredPackages)
                if(!isNaN(orderId)) {
                    const oldAddressId = this.weekOrders[orderId].addressId
                    const oldDayInWeek = this.weekOrders[orderId].dayInWeek
                    const oldProductId = this.weekOrders[orderId].product.id
                    // remove from week
                    const toRemoveId = this.weekOrders.findIndex(item => item.addressId === oldAddressId && item.dayInWeek === oldDayInWeek && item.product.id === oldProductId)
                    this.$store.dispatch('applyProductToCart', {
                        dayInWeek: oldDayInWeek,
                        addressId: oldAddressId,
                        product: this.weekOrders[toRemoveId].product,
                        amount: 0
                    })
                }
            }
            this.$store.dispatch('dragReset')
        }
    }
}
</script>
